import { setCookie, getCookie } from '../utils/cookies';

const selectors = {
    popup: '.js-newsletter-popup',
    form: '.js-newsletter-popup-form',
    close: '.js-newsletter-popup-close',
}

const init = () => {
    const popup = document.querySelector(selectors.popup);

    if (!popup) return;
    popup.classList.add('is-initialized');

    const closeBtn = popup.querySelector(selectors.close);
    const form = popup.querySelector(selectors.form);

    const newsletterClosed = getCookie('newsletter-closed');

    if (newsletterClosed) {
        popup.remove();
        return;
    } else {
        popup.removeAttribute('hidden');
    }

    closeBtn.addEventListener('click', () => {
        setCookie('newsletter-closed', 'true', 1);
        popup.remove();
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
       
        setCookie('newsletter-closed', 'true', 1);
        form.submit();
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;